module.exports = __webpack_public_path__ + "static/media/logoReMedia.5eda39d2.png";